<div style="width: 100%">
	<div class="footer-container">
		<span class="footer-text">&#169;2025 Texas Regional Bank. All Rights Reserved.</span>
	</div>
</div>
